const lodash = require('lodash');

export default {
    isArray(value) {
        return Array.isArray(value);
    },
    isObject(value) {
        return typeof value === 'object' && value !== null;
    },
    isUndefinedOrNull(value) {
        return this.isUndefined(value) || value === null;
    },
    isUndefinedOrNullOrIsEmptyObject(value) {
        return this.isUndefinedOrNull(value) || this.isEmptyObject(value);
    },
    isUndefinedOrNullOrIsEmpty(value) {
        return this.isUndefinedOrNull(value) || value === '';
    },
    isEmptyForAllTypes(value) {
        return this.isUndefinedOrNullOrIsEmpty(value) || (this.isArray(value) && 0 === value.length);
    },
    isUndefined(value) {
        return typeof value === 'undefined';
    },
    isFunction(value) {
        return typeof value === 'function';
    },
    isEmptyObject(value) {
        return lodash.isEmpty(value);
    },
    isString(value) {
        return typeof value === 'string';
    },
}


// WEBPACK FOOTER //
// ./src/services/ValueChecker.js